import ImgixClient from '@imgix/js-core';

import env from '@/public-runtime-env';

import type { GetImgixSrcParams } from '../types';
import getSrcUrl from './getSrcUrl';

const getImgixSrc = ({
  src,
  width,
  quality = 75,
  cdnOptions = {},
}: GetImgixSrcParams): string => {
  const imgixClient = new ImgixClient({
    domain: env.NEXT_PUBLIC_IMGIX_HEALTH_DOMAIN!,
    secureURLToken: env.NEXT_PUBLIC_IMGIX_HEALTH_URL_TOKEN!,
  });
  const srcUrl = getSrcUrl(src);

  return imgixClient.buildURL(srcUrl, {
    fm: 'webp',
    w: width,
    q: quality,
    ...cdnOptions,
  });
};

export default getImgixSrc;
